import download from "downloadjs";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import moment from "moment";

const createDeliveryOrderForm = async (original) => {
    try {
        // Create a new PDFDocument
        const pdfDoc = await PDFDocument.create();

        // Embed the Times Roman font
        const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman);

        const signatureImg = "/adminsignature.jpg";
        const signatureImageBytes = await fetch(signatureImg).then((res) =>
            res.arrayBuffer()
        );
        const signatureImage = await pdfDoc.embedJpg(signatureImageBytes);
        const signatureImageDims = signatureImage.scale(0.05);

        const totalPages =
            original.warranties.length <= 10
                ? 1
                : Math.ceil((original.warranties.length - 10) / 10 + 1);

        for (let i = 0; i < totalPages; i++) {
            // Add a blank page to the document
            const page = pdfDoc.addPage();
            const fontSize = 20;

            // Get the width and height of the page
            const { height } = page.getSize();

            if (i === 0) {
                const pageData = original.warranties.slice(i * 10, (i + 1) * 10);
                page.drawText(`HAOFA TOURBILLON (M) SDN. BHD.`, {
                    x: 60,
                    y: height - 2 * fontSize,
                    size: 14,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`(1477948-K)`, {
                    x: 300,
                    y: height - 2 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`B-1-01, Residensi The HERZ, Jalan 3/33a, `, {
                    x: 60,
                    y: height - 3 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`Kepong Baru, 52100 Kuala Lumpur,`, {
                    x: 60,
                    y: height - 4 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(
                    `Tel: 03-6243 0272   Email: haofamalaysia@gmail.com`,
                    {
                        x: 60,
                        y: height - 5 * fontSize,
                        size: 10,
                        font: timesRomanFont,
                        color: rgb(0, 0, 0),
                    }
                );

                page.drawText(`GST ID: 202201032251`, {
                    x: 60,
                    y: height - 6 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`Code:`, {
                    x: 370,
                    y: height - 3 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`${original.deliveryOrderNo}`, {
                    x: 410,
                    y: height - 3 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`Date:`, {
                    x: 370,
                    y: height - 4 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`${moment(original.createdAt).format("DD/MM/YYYY")}`, {
                    x: 410,
                    y: height - 4 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`Page:`, {
                    x: 370,
                    y: height - 5 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`${i + 1}`, {
                    x: 410,
                    y: height - 5 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`Return Form`, {
                    x: 230,
                    y: height - 8 * fontSize,
                    size: 14,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`From:`, {
                    x: 60,
                    y: height - 9 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`${original.transferredFrom.name},`, {
                    x: 60,
                    y: height - 10 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`${original.transferredFrom.address.lineOne}`, {
                    x: 60,
                    y: height - 11 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`${original.transferredFrom.address.lineTwo}`, {
                    x: 60,
                    y: height - 12 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(
                    `${original.transferredFrom.address.zip} ${original.transferredFrom.address.city}, ${original.transferredFrom.address.country}`,
                    {
                        x: 60,
                        y: height - 13 * fontSize,
                        size: 10,
                        font: timesRomanFont,
                        color: rgb(0, 0, 0),
                    }
                );

                page.drawText(`Delivered To:`, {
                    x: 370,
                    y: height - 9 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`${original.transferredTo.name},`, {
                    x: 370,
                    y: height - 10 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`${original.transferredTo.address.lineOne}`, {
                    x: 370,
                    y: height - 11 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`${original.transferredTo.address.lineTwo}`, {
                    x: 370,
                    y: height - 12 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(
                    `${original.transferredTo.address.zip} ${original.transferredTo.address.city}, ${original.transferredTo.address.country}`,
                    {
                        x: 370,
                        y: height - 13 * fontSize,
                        size: 10,
                        font: timesRomanFont,
                        color: rgb(0, 0, 0),
                    }
                );

                page.drawLine({
                    start: {
                        x: 60,
                        y: height - 14.25 * fontSize,
                    },
                    end: {
                        x: 520,
                        y: height - 14.25 * fontSize,
                    },
                    color: rgb(0, 0, 0),
                    opacity: 0.75,
                });

                page.drawText(`No`, {
                    x: 100,
                    y: height - 15 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`Product Code`, {
                    x: 180,
                    y: height - 15 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`Serial Number`, {
                    x: 360,
                    y: height - 15 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });


                page.drawLine({
                    start: {
                        x: 60,
                        y: height - 15.5 * fontSize,
                    },
                    end: {
                        x: 520,
                        y: height - 15.5 * fontSize,
                    },
                    color: rgb(0, 0, 0),
                    opacity: 0.75,
                });

                pageData.forEach((product, index) => {
                    page.drawText(`${index + 1}`, {
                        x: 100,
                        y: height - (16.5 + index * 1.5) * fontSize,
                        size: 10,
                        font: timesRomanFont,
                        color: rgb(0, 0, 0),
                    });

                    page.drawText(`${product.productColor}`, {
                        x: 180,
                        y: height - (16.5 + index * 1.5) * fontSize,
                        size: 10,
                        font: timesRomanFont,
                        color: rgb(0, 0, 0),
                    });

                    page.drawText(`${product.serialNumber}`, {
                        x: 360,
                        y: height - (16.5 + index * 1.5) * fontSize,
                        size: 10,
                        font: timesRomanFont,
                        color: rgb(0, 0, 0),
                    });
                });

                page.drawLine({
                    start: {
                        x: 60,
                        y: height - 30.75 * fontSize,
                    },
                    end: {
                        x: 520,
                        y: height - 30.75 * fontSize,
                    },
                    color: rgb(0, 0, 0),
                    opacity: 0.75,
                });

                page.drawText(`Remarks:`, {
                    x: 85,
                    y: height - 31.5 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawLine({
                    start: {
                        x: 60,
                        y: height - 32 * fontSize,
                    },
                    end: {
                        x: 520,
                        y: height - 32 * fontSize,
                    },
                    color: rgb(0, 0, 0),
                    opacity: 0.75,
                });

                page.drawText(`Please check and receive delivery of above mentioned goods in Good order & Condition. Any discrepancy in the bill or tampering`, {
                    x: 85,
                    y: height - 32.5 * fontSize,
                    size: 8,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`with the packaging seal, should at once be brought to the attention of the person concerned and will be dealt with accordingly.`, {
                    x: 85,
                    y: height - 33 * fontSize,
                    size: 8,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`Goods not in order must be returned for replacement within 14 days from date herein.`, {
                    x: 85,
                    y: height - 33.5 * fontSize,
                    size: 8,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawLine({
                    start: {
                        x: 60,
                        y: height - 36.75 * fontSize,
                    },
                    end: {
                        x: 220,
                        y: height - 36.75 * fontSize,
                    },
                    color: rgb(0, 0, 0),
                    opacity: 0.75,
                });

                page.drawText("Shipper Signature", {
                    x: 105,
                    y: height - 37.5 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawImage(signatureImage, {
                    x: 415,
                    y: height - 36.5 * fontSize,
                    width: signatureImageDims.width,
                    height: signatureImageDims.height,
                });

                page.drawLine({
                    start: {
                        x: 360,
                        y: height - 36.75 * fontSize,
                    },
                    end: {
                        x: 520,
                        y: height - 36.75 * fontSize,
                    },
                    color: rgb(0, 0, 0),
                    opacity: 0.75,
                });

                page.drawText("Authorized Signature", {
                    x: 405,
                    y: height - 37.5 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });
              

                page.drawLine({
                    start: {
                        x: 60,
                        y: height - 39.75 * fontSize,
                    },
                    end: {
                        x: 220,
                        y: height - 39.75 * fontSize,
                    },
                    color: rgb(0, 0, 0),
                    opacity: 0.75,
                });

                page.drawText("Applicant Signature", {
                    x: 105,
                    y: height - 40.5 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawLine({
                    start: {
                        x: 360,
                        y: height - 39.75 * fontSize,
                    },
                    end: {
                        x: 520,
                        y: height - 39.75 * fontSize,
                    },
                    color: rgb(0, 0, 0),
                    opacity: 0.75,
                });

                page.drawText("Receipient Signature", {
                    x: 405,
                    y: height - 40.5 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });
            } else {
                const pageData = original.warranties.slice(10 + (i - 1) * 10, 10 + i * 10);

                page.drawText(`HAOFA TOURBILLON (M) SDN. BHD.`, {
                    x: 60,
                    y: height - 2 * fontSize,
                    size: 14,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`(1477948-K)`, {
                    x: 300,
                    y: height - 2 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`B-1-01, Residensi The HERZ, Jalan 3/33a, `, {
                    x: 60,
                    y: height - 3 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                 page.drawText(`Kepong Baru, 52100 Kuala Lumpur,`, {
                    x: 60,
                    y: height - 4 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(
                    `Tel: 03-6243 0272   Email: haofamalaysia@gmail.com`,
                    {
                        x: 60,
                        y: height - 5 * fontSize,
                        size: 10,
                        font: timesRomanFont,
                        color: rgb(0, 0, 0),
                    }
                );

                page.drawText(`GST ID: 202201032251`, {
                    x: 60,
                    y: height - 6 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`Code:`, {
                    x: 370,
                    y: height - 3 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`${original.deliveryOrderNo}`, {
                    x: 410,
                    y: height - 3 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`Date:`, {
                    x: 370,
                    y: height - 4 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`${moment(original.createdAt).format("DD/MM/YYYY")}`, {
                    x: 410,
                    y: height - 4 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`Page:`, {
                    x: 370,
                    y: height - 5 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`${i + 1}`, {
                    x: 410,
                    y: height - 5 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`Return Form`, {
                    x: 230,
                    y: height - 8 * fontSize,
                    size: 14,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`From:`, {
                    x: 60,
                    y: height - 9 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`${original.transferredFrom.name},`, {
                    x: 60,
                    y: height - 10 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`${original.transferredFrom.address.lineOne}`, {
                    x: 60,
                    y: height - 11 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`${original.transferredFrom.address.lineTwo}`, {
                    x: 60,
                    y: height - 12 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(
                    `${original.transferredFrom.address.zip} ${original.transferredFrom.address.city}, ${original.transferredFrom.address.country}`,
                    {
                        x: 60,
                        y: height - 13 * fontSize,
                        size: 10,
                        font: timesRomanFont,
                        color: rgb(0, 0, 0),
                    }
                );

                page.drawText(`Delivered To:`, {
                    x: 370,
                    y: height - 9 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`${original.transferredTo.name},`, {
                    x: 370,
                    y: height - 10 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`${original.transferredTo.address.lineOne}`, {
                    x: 370,
                    y: height - 11 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`${original.transferredTo.address.lineTwo}`, {
                    x: 370,
                    y: height - 12 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(
                    `${original.transferredTo.address.zip} ${original.transferredTo.address.city}, ${original.transferredTo.address.country}`,
                    {
                        x: 370,
                        y: height - 13 * fontSize,
                        size: 10,
                        font: timesRomanFont,
                        color: rgb(0, 0, 0),
                    }
                );

                page.drawLine({
                    start: {
                        x: 60,
                        y: height - 14.25 * fontSize,
                    },
                    end: {
                        x: 520,
                        y: height - 14.25 * fontSize,
                    },
                    color: rgb(0, 0, 0),
                    opacity: 0.75,
                });

                page.drawText(`No`, {
                    x: 100,
                    y: height - 15 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`Product Code`, {
                    x: 180,
                    y: height - 15 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`Serial Number`, {
                    x: 360,
                    y: height - 15 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawLine({
                    start: {
                        x: 60,
                        y: height - 15.5 * fontSize,
                    },
                    end: {
                        x: 520,
                        y: height - 15.5 * fontSize,
                    },
                    color: rgb(0, 0, 0),
                    opacity: 0.75,
                });

                pageData.forEach((product, index) => {
                    page.drawText(`${index + 1 + (i * 10)}`, {
                        x: 100,
                        y: height - (16.5 + index * 1.5) * fontSize,
                        size: 10,
                        font: timesRomanFont,
                        color: rgb(0, 0, 0),
                    });

                    page.drawText(`${product.productColor}`, {
                        x: 180,
                        y: height - (16.5 + index * 1.5) * fontSize,
                        size: 10,
                        font: timesRomanFont,
                        color: rgb(0, 0, 0),
                    });

                    page.drawText(`${product.serialNumber}`, {
                        x: 360,
                        y: height - (16.5 + index * 1.5) * fontSize,
                        size: 10,
                        font: timesRomanFont,
                        color: rgb(0, 0, 0),
                    });

                    page.drawText(``, {
                        x: 330,
                        y: height - (16.5 + index * 1.5) * fontSize,
                        size: 10,
                        font: timesRomanFont,
                        color: rgb(0, 0, 0),
                    });
                });

                page.drawLine({
                    start: {
                        x: 60,
                        y: height - 30.75 * fontSize,
                    },
                    end: {
                        x: 520,
                        y: height - 30.75 * fontSize,
                    },
                    color: rgb(0, 0, 0),
                    opacity: 0.75,
                });

                page.drawText(`Remarks:`, {
                    x: 85,
                    y: height - 31.5 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawLine({
                    start: {
                        x: 60,
                        y: height - 32 * fontSize,
                    },
                    end: {
                        x: 520,
                        y: height - 32 * fontSize,
                    },
                    color: rgb(0, 0, 0),
                    opacity: 0.75,
                });

                page.drawText(`Please check and receive delivery of above mentioned goods in Good order & Condition. Any discrepancy in the bill or tampering`, {
                    x: 85,
                    y: height - 32.5 * fontSize,
                    size: 8,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`with the packaging seal, should at once be brought to the attention of the person concerned and will be dealt with accordingly.`, {
                    x: 85,
                    y: height - 33 * fontSize,
                    size: 8,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawText(`Goods not in order must be returned for replacement within 14 days from date herein.`, {
                    x: 85,
                    y: height - 33.5 * fontSize,
                    size: 8,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawLine({
                    start: {
                        x: 60,
                        y: height - 36.75 * fontSize,
                    },
                    end: {
                        x: 220,
                        y: height - 36.75 * fontSize,
                    },
                    color: rgb(0, 0, 0),
                    opacity: 0.75,
                });

                page.drawText("Shipper Signature", {
                    x: 105,
                    y: height - 37.5 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawImage(signatureImage, {
                    x: 415,
                    y: height - 36.5 * fontSize,
                    width: signatureImageDims.width,
                    height: signatureImageDims.height,
                });

                page.drawLine({
                    start: {
                        x: 360,
                        y: height - 36.75 * fontSize,
                    },
                    end: {
                        x: 520,
                        y: height - 36.75 * fontSize,
                    },
                    color: rgb(0, 0, 0),
                    opacity: 0.75,
                });

                page.drawText("Authorized Signature", {
                    x: 405,
                    y: height - 37.5 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });
              

                page.drawLine({
                    start: {
                        x: 60,
                        y: height - 39.75 * fontSize,
                    },
                    end: {
                        x: 220,
                        y: height - 39.75 * fontSize,
                    },
                    color: rgb(0, 0, 0),
                    opacity: 0.75,
                });

                page.drawText("Applicant Signature", {
                    x: 105,
                    y: height - 40.5 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });

                page.drawLine({
                    start: {
                        x: 360,
                        y: height - 39.75 * fontSize,
                    },
                    end: {
                        x: 520,
                        y: height - 39.75 * fontSize,
                    },
                    color: rgb(0, 0, 0),
                    opacity: 0.75,
                });

                page.drawText("Receipient Signature", {
                    x: 405,
                    y: height - 40.5 * fontSize,
                    size: 10,
                    font: timesRomanFont,
                    color: rgb(0, 0, 0),
                });
            }
        }

        // Serialize the PDFDocument to bytes (a Uint8Array)
        const pdfBytes = await pdfDoc.save();

        // Trigger the browser to download the PDF document
        download(pdfBytes, `deliveryForm-${moment(original.createdAt).format("DD/MM/YYYY")}`, "application/pdf");
    } catch (err) {
        alert("Failed");
        console.log(err);
    }
};

export default createDeliveryOrderForm;
